module.exports = __webpack_public_path__ + "static/media/right-bottom.3eb89f83.svg";